import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field, GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Şifremi unuttum" desc="E-posta adresinize tek kullanımlık bir sıfırlama bağlantısı göndereceğiz.">
      {msg ? (
        <div data-testid="forgot-success" className="text-sm text-emerald-400">{msg}</div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <Field label="E-posta">
            <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-white/5" />
          </Field>
          {err && <div className="text-sm text-red-400" data-testid="forgot-error">{err}</div>}
          <GradButton type="submit" disabled={busy} data-testid="forgot-submit" className="w-full justify-center h-11">Bağlantı gönder</GradButton>
        </form>
      )}
      <Link to="/login" data-testid="back-to-login" className="block mt-6 text-center text-sm text-muted-foreground hover:text-white">Girişe dön</Link>
    </AuthShell>
  );
}
